import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
  } from '@mui/material';
  import { useTranslation } from 'react-i18next';
  import Button from '../ui/Button';
  import { fullValidationSchema } from './EditReportModal';
  
  interface ViewReportModalProps {
    open: boolean;
    report: any;
    onClose: () => void;
  }
  
  const ViewReportModal = ({ open, report, onClose }: ViewReportModalProps) => {
    const { t } = useTranslation(['cnc-reports', 'common']);
  
    const displayableKeys = Object.keys(fullValidationSchema.fields);
  
    return (
      <Dialog open={open} onClose={onClose} >
        <DialogTitle>
          <Typography variant="h5" gutterBottom>
            {t('cnc-reports:view-modal.title')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: 'primary.light',
                    '& .MuiTableCell-root': { fontWeight: 'bold' },
                  }}
                >
                  <TableCell sx={{ width: 'auto' }}>{t('cnc-reports:view-modal.field')}</TableCell>
                  <TableCell sx={{ width: 'auto' }}>{t('cnc-reports:view-modal.value')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {displayableKeys.map((key, index) => (
                  <TableRow          key={key}                  >
                    <TableCell>{t(`cnc-reports:edit-modal.${key}`)}</TableCell>
                    <TableCell>
                      {report[key] !== undefined
                        ? typeof report[key] === 'boolean'
                          ? report[key]
                            ? t('common:yes')
                            : t('common:no')
                          : report[key]
                        : t('common:unknown')}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>
            {t('common:ok')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default ViewReportModal;
  